export const listTypeInfo = {
  dataTypes: [
    { name: '全部', id: '' },
    { name: '订货函', id: 1 },
    { name: '中选通知', id: 2 },
    { name: '中标通知', id: 3 },
  ],
  stockTypes: [
    { name: '全部', id: '' },
    { name: '询比价', id: 1 },
    { name: '公开招标', id: 2 },
    { name: '邀请招标', id: 3 },
    { name: '框架协议', id: 4 },
  ],
  availableList: [
    {name: '全部', id: ''},
    {name: '是', id: 1},
    {name: '空', id: -1},
  ],
  linkedList: [
    {name: '全部', id: ''},
    {name: '已关联', id: 1},
    {name: '待关联', id: 0},
  ],
};
export const tableLabel = [
  {
    label: '石化采购意向单编号',
    param: 'stockAffirmId',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '石化采购意向单名称',
    param: 'stockAffirmName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '是否已关联',
    align: 'center',
    minWidth: 110,
    render(row) {
      const data = {
        0: '待关联',
        1: '已关联',
      };
      return data[row.linked];
    },
  },
  /* @ApiModelProperty("采购方式（1：询比价，2：公开招标，3：邀请招标，4：框架协议执行）")
   */
  {
    label: '采购方式',
    param: 'stockType',
    align: 'center',
    minWidth: 100,
    render(row) {
      const data = {
        1: '询比价',
        2: '公开招标',
        3: '邀请招标',
        4: '框架协议',
      };
      return data[row.stockType];
    },
  },
  {
    label: '类型',
    param: 'dataType',
    align: 'center',
    minWidth: 100,
    render(row) {
      const { name } = listTypeInfo.dataTypes.find((item) => item.id === row.dataType);
      return name;
    },
  },
  {
    label: '买方',
    param: 'purchaserName',
    align: 'center',
    minWidth: 150,
  },
  {
    label: '编制时间',
    param: 'createDate',
    align: 'center',
    minWidth: 100,
  },
  {
    label: 'ERP单号',
    param: 'erpNo',
    align: 'center',
    minWidth: 100,
  },
  {
    label: '原材料订单',
    align: 'center',
    slot: 'purchaseList',
    width: 260,
  },
  {
    label: '备注',
    align: 'remark',
    minWidth: 100,
    slot: 'remark',
  },
  // 是否现货: 0:没有现货；1：现货供应
  {
    label: '是否现货',
    align: 'center',
    minWidth: 140,
    render(row) {
      const data = {
        '1': '是',
        '-1': '空',
      };
      return data[String(row.available)];
    },
    slot: 'available'
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];

export const getPurchaseList = (row) => {
  const { purchasePlanOrderList = [], purchasePlanStockList = [] } = row;
  const list = [...purchasePlanOrderList, ...purchasePlanStockList];
  return list;
};

export const getDataType = (row) => {
  const { name } = listTypeInfo.dataTypes.find((item) => item.id === row.dataType);
  return name;
};

export const fieldList = [
  {
    label: '石化采购意向单编号',
    type: 'input',
    value: 'stockAffirmId',
  },
  {
    label: '石化采购意向单名称',
    type: 'input',
    value: 'stockAffirmName',
  },
  {
    label: '采购方式',
    type: 'select',
    value: 'stockType',
    list: 'stockTypes',
  },
  {
    label: '类型',
    type: 'select',
    value: 'dataType',
    list: 'dataTypes',
  },
  {
    label: 'ERP单号',
    type: 'input',
    value: 'erpNo',
  },
  {
    label: '备注',
    type: 'input',
    value: 'remark',
  },
  {
    label: '编制时间',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
    clearable: false,
  },
  {
    label: '是否现货',
    type: 'select',
    value: 'available',
    list: 'availableList',
  },
  {
    label: '是否已关联',
    type: 'select',
    value: 'linked',
    list: 'linkedList',
  },
];

export const listQuery = {
  orderNo: '',
  companyName: '',
  start: '',
  end: '',
  pageNum: 1,
  pageSize: 10,
};
export const orderDrawerFieldList = [
  {
    label: '原材料订单编号',
    type: 'input',
    value: 'orderNo',
    hide: '2',
  },
  {
    label: '库存单编号',
    type: 'input',
    value: 'seqNo',
    hide: '1',
  },
  {
    label: '供应商名称',
    type: 'input',
    value: 'companyName',
  },
  {
    label: '库存录入时间',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
    clearable: false,
    hide: '1',
  },
  {
    label: '下单时间',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
    clearable: false,
    hide: '2',
  },
];
export const orderDrawerTableLabelAll = [
  {
    label: '原材料订单编号',
    param: 'no',
    tooltip: true,
    align: 'center',
    minWidth: 140,
    hide: '2',
  },
  {
    label: '库存单编号',
    param: 'no',
    tooltip: true,
    align: 'center',
    minWidth: 140,
    hide: '1',
  },
  {
    label: '订单类型',
    param: 'typeName',
    align: 'center',
    minWidth: 80,
  },
  {
    label: '订单状态',
    param: 'state',
    align: 'center',
    minWidth: 90,
    hide: '2',
  },
  {
    label: '供应商名称',
    param: 'supplierCompany',
    align: 'center',
    tooltip: true,
    minWidth: 140,
  },
  {
    label: '下单时间',
    param: 'createTime',
    align: 'center',
    minWidth: 100,
    hide: '2',
  },
  {
    label: '库存录入时间',
    param: 'createTime',
    align: 'center',
    minWidth: 100,
    hide: '1',
  },
];

export const rightOrderDrawerTableLabel = [
  {
    label: '原材料订单编号',
    param: 'no',
    tooltip: true,
    align: 'center',
    minWidth: 140,
  },
  {
    label: '订单类型',
    param: 'typeName',
    align: 'center',
    minWidth: 80,
  },
  {
    label: '供应商名称',
    param: 'supplierCompany',
    align: 'center',
    tooltip: true,
    minWidth: 140,
  },
];
